// Polyfills for older browsers
// @see https://reactjs.org/docs/javascript-environment-requirements.html
import 'core-js/es/array'
import 'core-js/es/map'
import 'core-js/es/set'
import 'raf/polyfill'

import React from 'react'
import { hydrate, render } from 'react-dom'
import 'bootstrap/dist/js/bootstrap'
import 'bootstrap/dist/css/bootstrap.css'

import './index.css'
import App from './App'
// TODO Re-enable service worker when we figure out caching issues
// import registerServiceWorker from './registerServiceWorker'
import { unregister } from './registerServiceWorker'

const rootElement = document.getElementById('root')
if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement)
} else {
  render(<App />, rootElement)
}

// registerServiceWorker()
unregister()



// WEBPACK FOOTER //
// ./src/index.js